import { IAlbum } from "@/@types/GaleriaFotos";
import { Loading } from "@/components/shared/Loading";
import { useEffect, useState } from "react";
import { apiCMS } from "@/services/api";

// const albunsData = [
//   {
//     title: "Paisagem Montanhosa",
//     image: "https://picsum.photos/id/1018/400/300",
//     description: "Montanhas ao fundo, um visual incrível",
//     totalalbum: 31,
//   },
//   {
//     title: "Campo Florido",
//     image: "https://picsum.photos/id/1025/400/300",
//     description: "Flores e cores vivas",
//     totalalbum: 12,
//   },
//   {
//     title: "Cidade Noturna",
//     image: "https://picsum.photos/id/1031/400/300",
//     description: "A cidade iluminada à noite",
//     totalalbum: 4,
//   },
//   {
//     title: "Paisagem Litorânea",
//     image: "https://picsum.photos/id/1003/400/300",
//     description: "Praia, mar e sol",
//     totalalbum: 4,
//   },
// ];

const url_fotos = 'https://www.feagri.unicamp.br/portal/extranet-galeria-de-fotos';
const url_foto = 'https://www.feagri.unicamp.br/portal/'

const GaleriaFotos = () => {
  const [galeriaData, setGaleriaData] = useState<IAlbum[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const slugify = (str: string) =>
    str
      .toLowerCase()
      .normalize("NFD")                         // remove acentos
      .replace(/[\u0300-\u036f]/g, "")         // remove acentos (cont.)
      .replace(/[^a-z0-9\s-]/g, "")            // remove símbolos
      .replace(/\s+/g, "-")                    // espaço vira hífen
      .replace(/-+/g, "-")                     // remove hífens duplicados
      .replace(/^-+|-+$/g, "");                // remove hífens nas pontas
  
  useEffect(() => {

        const getGaleriaFotos = async () => {
          try{          
            setIsLoading(true);
            const url = '/galeriaFotos/all';
            const response = await apiCMS.get(url)
            // console.log(response.data.result)
            setGaleriaData(response.data.result);

          } catch (err) {
            console.error(err);
          } finally {
            setIsLoading(false);
          } 
        }
        getGaleriaFotos();
  }, []);


  if (isLoading) {
    return (
      <div className="w-[full] h-[fulll] flex items-center justify-center">
        <Loading color="primary" />
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-4 w-full justify-center lg:justify-normal">
      {galeriaData.map((album) => (
        <div
        key={album.id}
        tabIndex={album.id}
          className="
            relative
            w-full
            md:w-[350px]
            h-[350px]
            rounded-sm
            overflow-hidden
            shadow
            cursor-pointer
            group
          "
          style={{
            backgroundImage: `url(${url_foto}${album.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          
        >
        <a
          href={`${url_fotos}/${slugify(album.title)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="absolute inset-0 z-20"
        ></a>
          <div
            className="
              absolute
              inset-0
              bg-black
              opacity-15
              group-hover:opacity-25
              group-hover:shadow-inner-dark
              transition-all
              duration-300
              ease-in-out
              bg-blend-multiply
            "
          ></div>

          <div
            className="
              absolute
              bottom-0
              left-0
              z-10
              w-full
              p-4
              text-white
            "
          >
            <h4 className="text-[18px] font-black text-white">{album.title}</h4>
            <span className="text-[13px] font-bold text-[rgba(255,255,255,.8)]">
              {album.totalalbum} Fotos
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export { GaleriaFotos };